const InputBoxStyles = {
  start: {
    left: "100%",
    width: "75vw",
    position: "absolute" /* 2 */,
    top: "50%" /* 3 */,
    transform: "translate(-100%, -50%)" /* 4 */,
  },
  end: {
    transition: "1s",
  },
  logoStyle: {
    width: "auto",
    height: "5vh",
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
  },
};

export default InputBoxStyles;
